import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import filterStore from '../filter.store';
import Checkbox from '../../../ui/checkbox';
import FloorPopup from '../FloorPopup/FloorPopup';
import { CustomFilterBodyProps } from '../customFilter.type';
import styles from './styles.module.scss';

const RoomCountBody: React.FC<CustomFilterBodyProps> = observer(
  ({ childs, handleChange, category, item }) => {
    const { openCategoryChild } = filterStore;
    const [data, setData] = useState<any>([...childs]);

    return (
      <FloorPopup
        onCancel={() => item.onCancel()}
        onSelect={() => {
          item.onConfirm(data);
        }}
        //     onCancel={() => openCategoryChild(category, item)} onSelect={() => {
        //     handleChange(data);
        //     openCategoryChild(category, item);
        // }}
        isSingle={!!item.isSingle}
      >
        <div className={styles.RoomCountBody}>
          {data.map((item: any, i: number) => (
            <React.Fragment key={item.title}>
              <Checkbox
                onChanges={() => {
                  const res = data;
                  res[i] = {
                    ...res[i],
                    selected: !res[i].selected,
                  };
                  setData([...res]);
                }}
                checked={item.selected}
              >
                <p className={styles.title}>{item.title || item.name}</p>
              </Checkbox>
            </React.Fragment>
          ))}
        </div>
      </FloorPopup>
    );
  },
);

export default RoomCountBody;
